module.exports = __webpack_public_path__ + "img/status-inactive.0bcdc15e.svg";